import { BookOutlined, DownOutlined, EditOutlined } from '@ant-design/icons'
import { Dropdown, Menu, MenuProps, Tooltip, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Favorite, getPointPermission, MosaicComponent, UserName } from '@/components'
import { HotResource } from '@/components/hot-resource/hot-resource.component'
import { ResourceUserEvaluationModal } from '@/components/resource-evaluation'
import { PAGE_RESOURCE_POINTS_ENUM, ResourceType } from '@/schemas'

import { Production, ProductionFlowStatus } from '../../production.schema'
import { ProductionEdit } from './production-edit.component'

interface ProjectHeaderContainerProps {
  project: Production
  refreshProject: () => void
}

export const ProductionHeaderContainer: React.FC<ProjectHeaderContainerProps> = ({
  project: production,
  refreshProject,
}) => {
  const { t } = useTranslation()

  const translateMap = {
    [ProductionFlowStatus.待立项申请]: t('production.flowStatus.ProjectWaitForApply.title'),
    [ProductionFlowStatus.待指派TO]: t('production.flowStatus.TOWaitForAssign.title'),
    [ProductionFlowStatus.待资源预估]: t('production.flowStatus.ResourceWaitForEstimate.title'),
    [ProductionFlowStatus.待立项审批]: t('production.flowStatus.ProjectWaitForAudit.title'),
    [ProductionFlowStatus.研发进行中]: t('production.flowStatus.DevOnGoing.title'),
    [ProductionFlowStatus.待IPD审批]: t('production.flowStatus.IPDWaitForAudit.title'),
    [ProductionFlowStatus.待产品验收]: t('production.flowStatus.ProductWaitForValidate.title'),
    [ProductionFlowStatus.待项目结项]: t('production.flowStatus.ProjectWaitForFinish.title'),
    [ProductionFlowStatus.项目已结项]: t('production.flowStatus.ProjectFinished.title'),
    [ProductionFlowStatus.项目已驳回]: t('production.flowStatus.ProjectRejected.title'),
    [ProductionFlowStatus.项目已关闭]: t('production.flowStatus.ProjectClosed.title'),
  }

  const [visible, setVisible] = React.useState(false)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [finishVisible, setFinishVisible] = React.useState(false)
  const [editVisible, setEditVisible] = React.useState(false)
  const { canUpdate } = getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况, production.permissions)

  const onClickMenu: MenuProps['onClick'] = ({ key }) => {
    if (key === 'edit') {
      setEditVisible(true)
      setVisible(false)
    }
  }

  // const isDone = production.progress === 100

  const menu = (
    <Menu onClick={onClickMenu}>
      <Menu.Item key='edit' icon={<EditOutlined />} disabled={!canUpdate}>
        {t('production.editInfo')}
      </Menu.Item>
    </Menu>
  )

  return (
    <div className='flex space-x-16px text-sm items-baseline max-w-full truncate'>
      <div>
        <BookOutlined style={{ fontSize: 18 }} />
      </div>
      <Dropdown trigger={['click']} overlay={menu} visible={visible} onVisibleChange={(visible) => setVisible(visible)}>
        <Typography.Text ellipsis className='cursor-pointer text-xl'>
          {production.name}
          <DownOutlined className='ml-4px' />
        </Typography.Text>
      </Dropdown>
      <div>
        <HotResource selfId={production.selfId} type={production.type} />
      </div>
      <div>
        <Favorite selfId={production.selfId} type={ResourceType.PRODUCTION} isFavourited={production.isFavourited} />
      </div>
      <div className='h-4 text-sm px-1'>
        {getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况_状态, production.permissions).canRead ? (
          translateMap[production.flowStatus]
        ) : (
          <MosaicComponent />
        )}
      </div>
      <Tooltip title={t('owner')}>
        <div>
          <UserName email={production.email} />
        </div>
      </Tooltip>
      <ResourceUserEvaluationModal
        resource={production}
        type={ResourceType.PRODUCTION}
        onRefresh={refreshProject}
        visible={finishVisible}
        onCancel={() => setFinishVisible(false)}
        width={'80%'}
      />
      <ProductionEdit
        production={production}
        visible={editVisible}
        onCancel={() => {
          setEditVisible(false)
          refreshProject()
        }}
      />
    </div>
  )
}
